import audio2 from '../../../../assets/sounds/adult/se/2 3 Ordkjedetest-Feil-los-tupp-meg-sa.mp3';
import audio3 from '../../../../assets/sounds/adult/se/2 4 Ordkjedetest-Feil-ost-par-vask-jakt.mp3';
import audio4 from '../../../../assets/sounds/adult/se/2 6 Ordkjedetest-Feil-hus-grei.mp3';

const assignments = [
	{
		id: 1,
		text: 'påsk last mil från',
		answer: 'påsk last mil från',
		locked: true, // ✅ disable the pre-solved example
	},
	{
		id: 2,
		text: 'lösuppmigsa',
		answer: 'lös upp mig sa',
		audio: audio2,
		count: 'andre',
	},
	{
		id: 3,
		text: 'ostparvaskjakt',
		answer: 'ost par vask jakt',
		audio: audio3,
		count: 'tredje',
	},
	{
		id: 4,
		text: 'husgrejsåssära',
		answer: 'hus grej sås sära',
		audio: audio4,
		count: 'fjerde',
	},
];

export default assignments;
